import React, { useState } from 'react';
import { Grid, TextField, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import axiosClient from 'http/axios-client';
import { useAlerts } from 'hooks/alerts-hooks';
import AppLoader from 'components/basic/AppLoader'; import NewBusinessUserInfoDialog from 'components/basic/dialogs/NewBusinessUserInfoDialog';

const useStyles = makeStyles({
  newButton: {
    margin: '5px 5px 5px 5px',
    fontSize: 18,
    borderColor: 'rgb(100, 141, 174)',
    color: '#f0f4f8',
    backgroundColor: 'rgb(100, 141, 174)',
    '&:hover': {
      backgroundColor: 'rgb(41, 58, 136)',
    },
  },
});

function ManagersEditCorporate({ selected, setOpenDialogEdit, refetch }) {
  const classes = useStyles();
  const { alertSuccess, alertError } = useAlerts();
  const [ newEmail, setNewEmail ] = useState(selected.email);
  const [ newName, setNewName ] = useState(selected.brand_name);
  const [ loading, setLoading ] = useState(false);
  const [ newPasswordModalOpen, setNewPasswordModalOpen ] = useState(false);
  const [ userDetails, setUserDetails ] = useState();

  const updateBusiness = () => {
    setLoading(true);
    if (selected.type !== 'Company' && (!newEmail.includes('@') || !newEmail.includes('.'))) {
      alertError('Email is not correct');
      setLoading(false);
      return;
    } if (newName.length === 0) {
      alertError('Name can not be empty');
      setLoading(false);
      return;
    }

    const data = { type: selected.type,
      email: newEmail.trim(),
      brand_name: newName,
      phone_number: selected.phone_number,
      country: selected?.country,
      email_locale: selected?.email_locale?.name || 'en-US',
      address: selected?.address,
      mother_business_id: selected?.mother_business?.id };

    axiosClient.put(`/businesses/update-super-and-sub-user/${ selected.id }`, data).then((dd) => {
      setLoading(false);
      if (dd?.password !== undefined) {
        setUserDetails({
          email: dd.email,
          password: dd.password,
        });
        setNewPasswordModalOpen(true);
      } else {
        setOpenDialogEdit(false);
        alertSuccess('Updated successfully.');
        refetch();
      }
    }).catch((e) => {
      alertError(`Fail to update ${ e?.response?.data?.message }`);
      setOpenDialogEdit(false);
      setLoading(false);
      refetch();
    });
  };

  if (loading) {
    return (
      <AppLoader />
    );
  }

  return (
    <Grid container display='flex' alignItems='center' spacing={ 2 }>
      <Grid item xs={ 12 } display='flex' alignItems='center'>
        <TextField
          fullWidth
          id='CorporationName'
          size='medium'
          value={ newName }
          onChange={ (e) => { setNewName(e.target.value); } }
          label='Enter Name'
          variant='outlined'
        />
      </Grid>
      <Grid item xs={ 12 } display='flex' alignItems='center'>
        <TextField
          fullWidth
          disabled={ selected?.sub !== null && selected?.sub !== undefined && selected?.sub !== '' }
          id='newCorporationEmail'
          size='medium'
          type='email'
          value={ newEmail }
          onChange={ (e) => { setNewEmail(e.target.value); } }
          label='Enter Email'
          variant='outlined'
        />
      </Grid>
      <Grid item xs={ 12 } display='flex' alignItems='center'>
        <Button
          className={ classes.newButton }
          variant='outlined'
          size='large'
          onClick={ updateBusiness }
        >
          UPDATE
        </Button>
      </Grid>
      { newPasswordModalOpen && userDetails.email !== undefined && (
        <NewBusinessUserInfoDialog
          open={ newPasswordModalOpen }
          handleClose={ () => {
            setOpenDialogEdit(false);
            setNewPasswordModalOpen(false);
            setUserDetails(undefined);
            alertSuccess('Updated successfully.');
            refetch();
          } }
          details={ userDetails }
        />
      )}
    </Grid>
  );
}

export default ManagersEditCorporate;
